import React from "react";
import { Box, Breadcrumbs, Button, IconButton, Link } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import RefreshIcon from "@mui/icons-material/Refresh";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";

const Toolbar = ({ currentPath, setCurrentPath, onUpload, onRefresh, onCreateFolder }) => (
  <Box display="flex" justifyContent="space-between" alignItems="center">
    <Breadcrumbs>
      {currentPath.split("/").map((part, i) => {
        const path = currentPath.split("/").slice(0, i + 1).join("/");
        return <Link key={i} onClick={() => setCurrentPath(path)} sx={{ cursor: "pointer" }}>{part}</Link>;
      })}
    </Breadcrumbs>
    <Box>
      <input type="file" hidden id="upload" onChange={onUpload} />
      <label htmlFor="upload">
        <Button variant="contained" startIcon={<CloudUploadIcon />} component="span">Upload</Button>
      </label>
      <IconButton onClick={onRefresh}><RefreshIcon /></IconButton>
      <IconButton onClick={onCreateFolder}><CreateNewFolderIcon /></IconButton>
    </Box>
  </Box>
);

export default Toolbar;
